// Small functions that help extract data from Product Descriptors
import { type PriceTable } from "~/domains/product/redux/types";
import { createCachedSelector } from "re-reselect";
import { type PriceInfo } from "~/domains/pricing/api/PriceInfo";

export const getPricingTable = createCachedSelector<PriceInfo, PriceInfo, PriceTable>(
  (priceInfo) => priceInfo,
  (priceInfo) => {
    return priceInfo.priceScale.map((cspEntry, index) => {
      const rspEntry = priceInfo.priceScaleRSP[index];
      const mspEntry = priceInfo.priceScaleMSP[index];
      const rebateEntry = priceInfo.rebateScale[index];

      const nextEntry = priceInfo.priceScale[index + 1];
      return {
        minQty: cspEntry.minQty,
        maxQty: nextEntry ? nextEntry.minQty - 1 : undefined,
        scaleIndex: index,
        csp: cspEntry.price,
        rsp: rspEntry ? rspEntry.price : undefined,
        msp: mspEntry ? mspEntry.price : undefined,
        rebate: rebateEntry ? rebateEntry.rebate : undefined,
      };
    });
  },
)(({ code, packCode, priceReference }) => `${code}-${packCode}-${priceReference}`);

export const getPricingEntry = (priceInfo: PriceInfo, qty: number) => {
  const table = getPricingTable(priceInfo);

  if (table.length === 0) {
    return null;
  }

  for (const entry of table) {
    if (entry.minQty <= qty && (entry.maxQty === undefined || qty <= entry.maxQty)) {
      return entry;
    }
  }
  return null;
};
